/** Ort zur PLZ: nur füllen, wenn das Feld leer ist. Ein vorhandener Ort bleibt. */

export function cityKeptOrFilled(currentCity, cities) {
  const current = String(currentCity ?? '');
  if (current.trim()) return current;
  const list = uniqueCities(cities);
  if (list.length === 1) return list[0];
  return current;
}

export function citiesToOffer(currentCity, cities) {
  const list = uniqueCities(cities);
  if (list.length >= 2) return list;
  const current = String(currentCity ?? '').trim();
  if (list.length === 1 && current && current !== list[0]) return list;
  return [];
}

function uniqueCities(cities) {
  const list = [];
  (cities || []).forEach((raw) => {
    const name = String(raw || '').trim();
    if (name && !list.includes(name)) list.push(name);
  });
  return list;
}
